const toggleButton = document.querySelector('.js-header-mega-menu-toggler');
const closeButton = document.querySelector('.mega-menu-close');
const megaMenu = document.querySelector('.header-mega-menu');

function toggleMegaMenu() {
  document.documentElement.classList.toggle('mega-menu-active');
}
function closeMegaMenu() {
  megaMenu.classList.toggle('is-active');
}


if (toggleButton) {
  toggleButton.addEventListener('click', toggleMegaMenu);
}

if (closeButton) {
  closeButton.addEventListener('click', toggleMegaMenu);
  closeButton.addEventListener('click', closeMegaMenu);
}

function onResizeMegaMenu() {
    // Remove class when the window is 1200px or wider
    if (window.innerWidth >= 1199) {
        document.documentElement.classList.remove('mega-menu-active');
    }
}

function onEscKey(event) {
    // Check if the Esc key (key code 27 or 'Escape') is pressed
    if (event.key === 'Escape' || event.keyCode === 27) {
        document.documentElement.classList.remove('mega-menu-active');
    }
}

// Initial state
onResizeMegaMenu();

// On resize
window.addEventListener('resize', onResizeMegaMenu);

// On Esc key press
window.addEventListener('keydown', onEscKey);

